import React from 'react'
import { TextField, Grid, } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import { connect } from 'react-redux'
import * as common from '../../appRedux/actions/common'
import * as field from '../../appRedux/actions/field'
import * as info from '../../appRedux/actions/info'
import IntlMessages from '../../util/IntlMessages'
import Comeback from '../../components/comeback'
import * as router from '../../constants/router'
import useStyles from './styles'

function Index(props) {
    const classes = useStyles()
    const onChangeHandler = (data, field) => props.setFields([{ data, field }])

    return (
        <React.Fragment>
            <Comeback
                redirectLink={router.PROFILE}
                title={<IntlMessages id="changePassword" />} />
            <Grid className={classes.root}>
                <TextField
                    value={props.password}
                    onChange={(e) => onChangeHandler(e.target.value, 'password')}
                    fullWidth
                    autoFocus
                    required
                    margin="normal"
                    label={<IntlMessages id="password" />}
                    type="password"
                    variant="filled" />
                <TextField
                    value={props.repeatPassword}
                    onChange={(e) => onChangeHandler(e.target.value, 'repeatPassword')}
                    fullWidth
                    required
                    type="password"
                    label={<IntlMessages id="repeatPassword" />}
                    variant="filled" />
                <LoadingButton
                    onClick={() => props.operatorUpdatePasswordAction()}
                    loading={props.loadingBtn}
                    variant="contained"
                    fullWidth
                    size="large"
                    color="primary"
                >
                    <IntlMessages id="changePassword" />
                </LoadingButton>
            </Grid>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        password: state.field.password,
        loadingBtn: state.common.loadingBtn
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setFields: (data) => dispatch(field.setFields(data)),
        redirectAction: (router) => dispatch(common.redirectAction(router)),
        operatorUpdatePasswordAction: () => dispatch(info.operatorUpdatePasswordAction())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
